import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, useApiIsLoaded } from '@vis.gl/react-google-maps';
import Loader from '../../../components/Loader';
import mapErrorImage from '../../../../assets/images/map-error.jpg';

LocationMap.propTypes = {
  location: PropTypes.object.isRequired,
  cursor: PropTypes.string
};

const hide = {
  stylers: [{visibility: 'off'}]
};

/*
 * Docs for changing map styles can be found here:
 * https://developers.google.com/maps/documentation/javascript/style-reference
 */
const MAP_STYLES = [
  {featureType: 'administrative', ...hide},
  {featureType: 'poi', ...hide},
  {featureType: 'transit', ...hide},
];

export default function LocationMap(props) {
  const {location, cursor = 'pointer'} = props;

  const apiIsLoaded = useApiIsLoaded();

  const latitude = Number(location?.data?.latitude);
  const longitude = Number(location?.data?.longitude);

  const hasCoordinates = (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    !(latitude === 0 && longitude === 0)
  );

  if (!hasCoordinates) {
    return (
      <div className="cs-map">
        <img src={mapErrorImage} alt="Map Error"/>
      </div>
    );
  }

  if (!apiIsLoaded) {
    return (
      <div className="cs-map">
        <Loader/>
      </div>
    );
  }

  const position = {lat: latitude, lng: longitude};

  return (
    <Map
      className="cs-map"
      defaultCenter={position}
      defaultZoom={13}
      styles={MAP_STYLES}
      // hide controls and make the map non-interactive
      draggable={false}
      disableDefaultUI={true}
      clickableIcons={false}
      keyboardShortcuts={false}
      gestureHandling="none"
      draggableCursor={cursor}
    >
      <Marker position={position}/>
    </Map>
  );
};
